var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container",class:{fullscreen:_vm.fullscreen},style:({width:_vm.containerWidth})},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }